import { useLazyQuery } from "@apollo/client";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Icon,
  IconButton,
  Typography,
} from "@mui/material";

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import MemberBox from "../../../components/Administration/UserGroups/MemberBox";
import { GET_GROUP_MEMBERS } from "../../../graphql/queries";
import { getCurrentCompanyId } from "../../../helpers/selectors";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import { FormattedMessage, useIntl } from "react-intl";
import { useGetCompanyGroups } from "../../../hooks";
import UserGroupTree from "../../../components/Administration/UserGroups/UserGroupTree";
import getGroupDataStructure from "../../../helpers/getGroupTreeDataStructure";
import AdminCompanySelector from "../../../components/Administration/AdminCompanySelector";

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.common.white,
    border: "1px solid #EEE",
    boxShadow: "0 2px 0 0 rgba(129,129,129,0.10)",
    borderRadius: 10,
  },
  select: {
    width: 160,
    marginLeft: 7,
    marginRight: 7,
  },
  textField: {
    width: 300,
    marginTop: 0,
    marginLeft: 7,
  },
  head: {
    padding: "15px 20px",
    borderBottom: "2px solid #F5F5F5",
    display: "flex",
    alignItems: "center",
    fontWeight: 600,
  },
  headTitle: {
    fontSize: 16,
    fontWeight: 600,
    marginRight: 20,
  },
  headSubTitle: {
    fontSize: 11,
  },
  addLink: {
    fontSize: 12,
    color: theme.palette.primary.main,
    marginLeft: "auto",
    padding: 0,
    textTransform: "none",
    fontWeight: 600,
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "transparent",
      opacity: 0.8,
    },
  },
  addIcon: {
    width: "unset",
    height: "unset",
    overflow: "unset",
    fontSize: 12,
    marginRight: 8,
    marginTop: 3,
  },
  body: {
    padding: 20,
    "& .MuiGrid-container": {
      marginTop: 0,
      marginBottom: 0,
    },
    "& .MuiGrid-container > .MuiGrid-item": {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  foot: {
    padding: "15px 20px",
    borderTop: "2px solid #F5F5F5",
  },
  btnSave: {
    padding: "10px 15px",
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.common.blue,
    "&:hover": {
      backgroundColor: theme.palette.common.blue,
      opacity: 0.8,
    },
  },
  btnIcon: {
    fontSize: 14,
    marginRight: 8,
    verticalAlign: "middle",
  },
  borderLeft: {
    borderLeft: "1px solid #efefef",
  },
  pagination: {
    marginLeft: "auto",
  },
  divider: {
    borderTop: "1px solid",
    borderTopColor: theme.palette.component.detailedSearchBorder,
    marginTop: 5,
    paddingTop: 5,
    textAlign: "right",
  },
  newGroupBtn: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      opacity: 0.8,
    },
    textTransform: "unset",
    borderRadius: "15px",
    padding: 4,
    float: "right",
  },
  newGroupBtnCont: {
    fontSize: 14,
    color: theme.palette.primary.contrastText,
  },
  membersContainer: {
    display: "flex",
    flexWrap: "wrap",
  },
}));

const ManageMissingTable = () => {
  const companyId = useSelector(getCurrentCompanyId);
  const [getGroupMembers, { data: groupMembersData, loading: groupMembersLoading }] = useLazyQuery(GET_GROUP_MEMBERS);
  const [ungroupedUsers, setUngroupedUsers] = useState([]);


  const { execute: getCompanyGroups, loading } = useGetCompanyGroups();
  const { groups } = useSelector(state => state.api.companyAdmin.companyGroups);



  const classes = useStyles();
  const intl = useIntl();

  useEffect(() => {
    if (companyId) {
      getGroupMembers({
        variables: {
          companyId,
          groupId: -1,
          companyRoleId: 0,
          searchTerm: "",
          offset: 0,
          pagesize: 50,
        },
      });

      handleFetchCompanyGroups();

    }
  }, [companyId, getGroupMembers]);

  useEffect(() => {
    if (groupMembersData) {
      const users = groupMembersData?.companyAdminContext?.companyGroupSettings?.getGroupMembers?.companyUsersListItems || [];
      setUngroupedUsers(users);
    }
  }, [groupMembersData]);

  const [groupTree, setGroupTree] = useState({});
  const [openedNodes, setOpenedNodes] = useState([]);
  const [selectedNode, setSelectedNode] = useState({});

  const [isNewRootGroupMode, setIsNewRootGroupMode] = useState(false);

  const [selectedGroupId, setSelectedGroupId] = useState(0);
  const [members, setMembers] = useState([]);

  const [selectedMembers, setSelectedMembers] = useState([]);
  const [roleOptions, setRoleOptions] = useState([]);

  const [refreshSearch, setRefreshSearch] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [companyRoleId, setCompanyRoleId] = useState(0);
  const [perPage, setPerPage] = useState(25);
  const [totalCount, setTotalCount] = useState(null);
  const [page, setPage] = useState(0);

  const [selectedUserId, setSelectedUserId] = useState(null);
  const [userModal, setUserModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [editAddressModal, setEditAddressModal] = useState(false);

  const [nameModal, setNameModal] = useState(false);
  const [openRenameModal, setOpenRenameModal] = useState(false);

  const handleOpenUserModal = (type, userId = null) => {
    setSelectedUserId(userId);
    setUserModal(true);
  };

  const handleCloseUserModal = result => {
    setUserModal(false);
    setSelectedUserId(null);
  };


  const handleAddNewUserGroup = () => {

  }

  const handleOpenNode = () => {

  }

  const handleContextMenu = () => {

  }

  const onGroupRowClick = () => {

  }

  const handleUsersMoved = () => {
    getGroupMembers({
      variables: {
        companyId,
        groupId: -1,
        companyRoleId: 0,
        searchTerm: "",
        offset: 0,
        pagesize: 50,
      },
    });
  }

  const handleFetchCompanyGroups = () => {
    getCompanyGroups({ variables: { companyId } });
  };

  const handleOpenDeleteModal = () => {
  }

  useEffect(() => {
    if (Array.isArray(groups)) {
      const newGroupTree = getGroupDataStructure({ groups });
      setGroupTree(newGroupTree);
    }
  }, [groups]);



  return (
    <>      
      <Grid container spacing={4}>
        <Grid item xs={12} md={3}>
          {loading && <CircularProgress size={18} />}

          {!loading && (
            <>
              <div className={classes.divider}>
              </div>

              <UserGroupTree
                groupTree={groupTree}
                setGroupTree={setGroupTree}
                handleOpenNode={handleOpenNode}
                moveFolderEnabled
                openedNodes={openedNodes}
                setOpenedNodes={setOpenedNodes}
                handleContextMenu={handleContextMenu}
                selectedFolderIds={[selectedGroupId]}
                onGroupRowClick={onGroupRowClick}
                onUsersMoved={handleUsersMoved}
                refetch={handleFetchCompanyGroups}
              />
            </>
          )}

        </Grid>


        <Grid item xs={12} md={9} className={classes.borderLeft}>
          <Grid container spacing={3} className={classes.membersContainer}>
            {groupMembersLoading && <CircularProgress size={18} />}
            {!groupMembersLoading && (
              <>
                {ungroupedUsers.map(member => {
                  return (
                    <MemberBox
                      key={`user-${member.userId}`}
                      member={member}
                      handleOpenUserModal={handleOpenUserModal}
                      handleOpenDeleteModal={handleOpenDeleteModal}
                      setSelectedMembers={setSelectedMembers}
                      selectedMembers={selectedMembers}
                      setOpenedNodes={setOpenedNodes}
                      setSelectedGroupId={setSelectedGroupId}
                    />
                  );
                })}
              </>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ManageMissingTable;